import { render, staticRenderFns } from "./waterHazardReview.component.vue?vue&type=template&id=c2f7af32&"
import script from "./waterHazardReview.component.vue?vue&type=script&lang=js&"
export * from "./waterHazardReview.component.vue?vue&type=script&lang=js&"
import style0 from "./waterHazardReview.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports